<template>
    <crud-facecade-tree
        ref="permlist"
        :showSequence="true"
        :url="url"
        :treeCol="treeCol"
        :defaultSort="{ prop: 'id', order: 'descending' }"
        :columns="columnList"
        :treeStyle="true"
        :expandall="false"
        :fuzzySearch="false"
        :parentField="parentField"
        :tableHeight="tableHeight"
        :addButton="{ permission: 'permission:create' }"
        :deleteButton="{ enabled: true, permission: 'permission:delete' }"
        :updateButton="{ permission: 'permission:update' }"
    >
        <slot slot="filter">
            <el-col :span="4" class="padding-right10">
                <item-input type="search" placeholder="关键字搜索" v-model="searchValue" @input="search()" class="width-p100"></item-input>
            </el-col>
        </slot>
        <slot slot="filter-after"> </slot>
    </crud-facecade-tree>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `Permission`,
    data() {
        return {
            title: `权限管理`,
            permissions: [],
            treeCol: `名称`,
            parentField: `parent_id`,
            menus: [],
            searchValue: undefined,
            url: {
                baseURL: `/api/AcisSystem/Permission`,
                get: () => {
                    return this.loadPermissions()
                }
            }
        }
    },
    created() {
        this.loadMenus()
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        leafMenus() {
            return this.menus.filter(m => {
                return m.parent_id != 0
            })
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `description`,
                    label: `名称`,
                    // width: "180",
                    isListable: true,
                    searchable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `parent_id`,
                    label: `父级`,
                    width: `180`,
                    isListable: false,
                    isExpand: false,
                    // readonly: (that, { row }) => {
                    //     if (row.origion && row.origion.id > 0) {
                    //         return (row.origion.children && row.origion.children.length > 0)
                    //     } else {
                    //         return false
                    //     }
                    // },
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: true,
                    meta: {
                        parents: this.permissions
                    },
                    options: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return _.filter(column.meta.parents, function(d) {
                                return d.value !== row.origion.id
                            })
                        } else {
                            return column.meta.parents
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `no`,
                    label: `代码`,
                    // width: "180",
                    isListable: true,
                    searchable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `permission_type`,
                    label: `类型`,
                    // width: "180",
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    options: [
                        { value: `权限组`, label: `权限组` },
                        { value: `权限`, label: `权限` }
                    ],
                    default: `权限组`
                },
                {
                    type: `string`,
                    prop: `permission`,
                    label: `权限代码`,
                    // width: "180",
                    isListable: true,
                    searchable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
        }
    },
    methods: {
        loadPermissions() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/Permission/Get`)
                req.then(data => {
                    that.permissions = _.map(data, d => {
                        return { value: d.id, label: d.description }
                    })
                    var searchResult = []
                    data.forEach(d => {
                        d.name = d.description
                        let tmpResult = this.filterCondition(d)
                        if (tmpResult == true) {
                            searchResult.push(d)
                        } else if (this.isParent(d, data)) {
                            let ch = _.filter(data, x => x[this.parentField] == d.id && this.filterCondition(x))
                            if (ch && ch.length > 0) {
                                searchResult.push(d)
                            }
                        }
                    })
                    searchResult = that.$refs.permlist.$refs.treeTableNew.toTree(searchResult)
                    resolve(searchResult)
                }).catch(e => {
                    console.log(e)
                    reject(e)
                })
            })
        },
        loadMenus() { // 获取菜单
            let that = this
            let req = this.myaxios.get(`/api/AcisSystem/Menu/Get`)
            req.then(data => {
                that.menus = _.filter(data, d => d.is_deleted == false).map(d => {
                    return { value: d.id, label: d.name, parent_id: d.parent_id }
                })
                console.log(`menus`)
                console.log(that.menus)
            }).catch(e => {
                console.log(e)
            })
        },
        filterCondition(d) {
            if (this.searchValue) {
                return (d.description && d.description.indexOf(this.searchValue) > -1) ||
                                     (d.permission && d.permission.indexOf(this.searchValue) > -1) ||
                                (d.no && d.no.indexOf(this.searchValue) > -1)
            }
            return true
        },
        isParent(d, data) {
            return (!d[this.parentField] || d[this.parentField] == 0) || (_.findIndex(data, p => p.parent_id == d.id) > -1)
        },
        search() {
            this.$refs[`permlist`].ReloadListData()
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Permission/Index.vue